import { Component, Host, Element, h, Prop } from '@stencil/core';

@Component({
  tag: 'bam-richtext',
  styleUrl: 'bam-richtext.scss',
})
export class BamRichtext {
  @Element() el: HTMLElement;

  @Prop() inverted: boolean = false;

  setRichTextClasses() {
    const defaultLists = this.el.querySelectorAll('ul:not(.is-linklist):not(.is-list):not(.is-download):not(.is-bullet-check-circle):not(.has-bullet-arrow-down)');
    const discLists = this.el.querySelectorAll('.is-list');
    const linkListElements = this.el.querySelectorAll('.is-linklist li');
    const downloadLinkElements = this.el.querySelectorAll('.is-download li');
    const circleBulletLists = this.el.querySelectorAll('ul.is-bullet-check-circle');

    circleBulletLists.forEach(list => {
      list.classList.add('list');
      list.classList.add('has-bullet-check-circle');
    });

    discLists.forEach(list => {
      list.classList.add('is-inside')
    })

    defaultLists.forEach(list => {
      list.classList.add('list');
      Array.from(list.children).map(item => {
        if (!item.classList.contains('is-dot')) {
          list.classList.add('has-bullet-check');
        }
        if (!item.classList.contains('is-dot') && !item.classList.contains('is-cross') && !item.classList.contains('is-excluded') && !item.classList.contains('is-forbidden')) {
          item.classList.add('has-bullet-check');
          return;
        }
        if (item.classList.contains('is-cross') || item.classList.contains('is-excluded') || item.classList.contains('is-forbidden')) {
          item.classList.add('has-bullet-close');
          item.classList.add('opacity-50');
        }
      });
    });

    linkListElements.forEach(linkListEl => {
      const link = linkListEl.querySelector('a') ? linkListEl.querySelector('a') : null;
      const linkType = link && link.className.split(' ')[0] === 'is-external' ? 'link' : 'nav-go-right';
      linkListEl.innerHTML += `<bal-list-item-icon right><bal-icon name="${linkType}" size="xsmall"></bal-icon></bal-list-item-icon>`;
    });

    downloadLinkElements.forEach(downloadEl => {
      const link = downloadEl.querySelector('a') ? downloadEl.querySelector('a') : null;
      const linkType = link && link.className.split(' ')[0] === 'is-img' ? 'picture' : 'pdf';

      downloadEl.innerHTML = `<bal-icon name="${linkType}" class="mr-normal"></bal-icon>
                              ${downloadEl.innerHTML}
                              <bal-icon right class="ml-normal"><bal-icon name="download" size="small"></bal-icon>`;
    });
  }

  componentWillLoad() {
    this.setRichTextClasses();
  }

  render() {
    return (
      <Host
        class={{
          'bam-richtext': true,
          'is-inverted': this.inverted,
        }}
      >
        <slot></slot>
      </Host>
    );
  }
}
